// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.app-pages-HR-HRSettings-PeopleTableEditor-___PeopleTableEditorSchema-module__tableTitle {
  display: flex;
  flex-direction: row;
  align-content: center;
  align-items: center;
  flex-wrap: nowrap;
  font-weight: bold;
  font-size: 20px;
  line-height: 20px;
  height: 55px;
  position: sticky;
  top: 0;
  background-color: #ffffff;
  z-index: 10;
  padding: 15px;
}

  .app-pages-HR-HRSettings-PeopleTableEditor-___PeopleTableEditorSchema-module__tableTitle:hover > .app-pages-HR-HRSettings-PeopleTableEditor-___PeopleTableEditorSchema-module__viewTableButton {
    opacity: 0.5;
  }

.app-pages-HR-HRSettings-PeopleTableEditor-___PeopleTableEditorSchema-module__viewTableButton {
  cursor: pointer;
  opacity: 0.3;
  padding-left: 6px;
  font-size: 18px;
}

.app-pages-HR-HRSettings-PeopleTableEditor-___PeopleTableEditorSchema-module__viewTableButton:hover {
    opacity: 1 !important;
  }
`, "",{"version":3,"sources":["webpack://./app/pages/HR/HRSettings/PeopleTableEditor/PeopleTableEditorSchema.module.scss"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;EACnB,qBAAqB;EACrB,mBAAmB;EACnB,iBAAiB;EACjB,iBAAiB;EACjB,eAAe;EACf,iBAAiB;EACjB,YAAY;EACZ,gBAAgB;EAChB,MAAM;EACN,yBAAyB;EACzB,WAAW;EACX,aAAa;AAKf;;EAHE;IACE,YAAY;EACd;;AAGF;EACE,eAAe;EACf,YAAY;EACZ,iBAAiB;EACjB,eAAe;AAKjB;;AAHE;IACE,qBAAqB;EACvB","sourcesContent":[".tableTitle {\n  display: flex;\n  flex-direction: row;\n  align-content: center;\n  align-items: center;\n  flex-wrap: nowrap;\n  font-weight: bold;\n  font-size: 20px;\n  line-height: 20px;\n  height: 55px;\n  position: sticky;\n  top: 0;\n  background-color: #ffffff;\n  z-index: 10;\n  padding: 15px;\n\n  &:hover > .viewTableButton {\n    opacity: 0.5;\n  }\n}\n\n.viewTableButton {\n  cursor: pointer;\n  opacity: 0.3;\n  padding-left: 6px;\n  font-size: 18px;\n\n  &:hover {\n    opacity: 1 !important;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"tableTitle": `app-pages-HR-HRSettings-PeopleTableEditor-___PeopleTableEditorSchema-module__tableTitle`,
	"viewTableButton": `app-pages-HR-HRSettings-PeopleTableEditor-___PeopleTableEditorSchema-module__viewTableButton`
};
export default ___CSS_LOADER_EXPORT___;
